import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  HttpResponse,
  ShortlistCandidaciesSegmentedByOwnership,
} from "@/types";

export function useGetShortlistCandidaciesSegmentedByOwnership({
  enabled,
}: { enabled?: boolean } = {}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "candidacies/shortlist_candidacies_segmented_by_ownership",
      currentCompanyId,
      currentJobId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/shortlist_candidacies_segmented_by_ownership`;
      const res = await guacHttpClient.get<
        ShortlistCandidaciesSegmentedByOwnership,
        HttpResponse<ShortlistCandidaciesSegmentedByOwnership>
      >(path);
      return res.data;
    },
    enabled: (enabled ?? true) && !!currentCompanyId && !!currentJobId,
  });
}
